import React, { useState } from "react";

function LocationPermissionWidget({ onLocation }) {
  const [status, setStatus] = useState("");

  const handleGetLocation = () => {
    if (!navigator.geolocation) {
      setStatus("Geolocation not supported");
      return;
    }
    setStatus("Requesting...");
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setStatus("Location allowed");
        onLocation && onLocation(pos.coords);
      },
      (err) => {
        setStatus("Permission denied");
      },
    );
  };

  return (
    <div>
      <button onClick={handleGetLocation} style={{ marginBottom: 8 }}>
        Allow Location Access
      </button>
      <div style={{ fontSize: 12, color: "#888" }}>{status}</div>
    </div>
  );
}

export default LocationPermissionWidget;
